// @ts-check

import { checkStrings } from 'libs/types/checkTypes';
import USER from '../ts/profileEditorEnum';
import {
	validateFirstName,
	validateLastName,
	validateUsername,
	validatePhones,
	validateEmail,
	VALID_MSG,
	validatePassword,
} from '@sds-stream/function-validations';

/**
 * @function validProfileEditorUser
 * @param {string} name
 * @param {*} payload
 * @param {string} password
 * @param {string} confirmPassword
 * @param {(name:string, hasError:boolean, errorMessage:string)=>void} onValid
 * @returns {void}
 */
function validProfileEditorUser(name, payload, password, confirmPassword, onValid) {
	checkStrings(name);

	switch (name) {
		case USER.FIRST_NAME: {
			const { hasError, errorMessage } = validateFirstName(payload);
			onValid(name, hasError, errorMessage);
			break;
		}

		case USER.LAST_NAME: {
			const { hasError, errorMessage } = validateLastName(payload);
			onValid(name, hasError, errorMessage);
			break;
		}

		case USER.USERNAME: {
			const { hasError, errorMessage } = validateUsername(payload);
			onValid(name, hasError, errorMessage);
			break;
		}

		case USER.PHONE_WORK:
		case USER.PHONE_MOBILE:
		case USER.PHONE_OTHER: {
			const { hasError, errorMessage } = validatePhones(
				payload[name].replace(/-/g, ''),
				payload[`${name}CountryCode`],
				payload[`${name}DialCode`],
				payload[`${name}Ext`],
			);
			onValid(name, hasError, errorMessage);
			break;
		}

		case USER.EMAIL_WORK:
		case USER.EMAIL_PERSONAL:
		case USER.EMAIL_OTHER: {
			const { hasError, errorMessage } = validateEmail(payload);
			onValid(name, hasError, errorMessage);
			break;
		}

		case USER.CONTACT_TYPES:
		case USER.ROLE_GROUPS:
		case USER.COMPANIES: {
			const hasError = payload.length === 0;
			const errorMessage = hasError ? VALID_MSG.SELECTOR_REQUIRED : '';
			onValid(name, hasError, errorMessage);
			break;
		}

		case USER.ACCESSIBLE: {
			const hasError = payload === null;
			const errorMessage = hasError ? VALID_MSG.SELECTOR_REQUIRED : '';
			onValid(name, hasError, errorMessage);
			break;
		}

		case USER.PASSWORD: {
			if (payload.trim().length > 0) {
				const { hasError, errorMessage } = validatePassword(payload);
				onValid(name, hasError, errorMessage);
			} else if (payload.trim().length === 0) {
				onValid(name, false, '');
				onValid(USER.CONFIRM_PASSWORD, false, '');
			}
			break;
		}

		case USER.CONFIRM_PASSWORD: {
			if (password === payload.trim()) {
				onValid(name, false, '');
			} else {
				onValid(name, true, VALID_MSG.PASSWORD_MISMATCH);
			}
			break;
		}

		default:
			break;
	}
}

export default validProfileEditorUser;
